import { v4 as uuid } from 'uuid'
import { outsideInstructionInterface, recipeObjectInterface, recipeSubStepInterface, recipeVariationStepInterface, recipeVariatonObjectInterface, stepObjectInterface, timerInstructionInterface } from '../../app/recipeCreation/createRecipe.types'
import { HeatingModeEnum } from './utils/constants'

export const defaultRecipeTableData = (recipeName: string, imageURL: string, servingSize: number, userId: string) => {
  const recipeId = uuid()
  const recipeVariatonId = uuid()
  const stepId = uuid()
  const subStepIdOutsideInstruction = uuid()
  const subStepUId = uuid()
  const subStepIdInstruction = uuid()
  const currentDate = new Date();
  const formattedDate = currentDate.toUTCString();

  const recipeObject: recipeObjectInterface = {
    id: recipeId,
    active: true,
    author: userId,
    created_by: userId,
    cuisine: ["Created"],
    name: recipeName,
    created_at: formattedDate,
    last_edited_at: formattedDate,
    created_source: "mobileApp",
    editor: userId,
    description: null,
    diet: [],
    recipe_market_price: 0
  }

  const recipeVariatonObject: recipeVariatonObjectInterface = {
    id: recipeVariatonId,
    cooking_time: 0,
    prep_time: 0,
    active: true,
    min_serving: servingSize,
    max_serving: servingSize,
    image_url: imageURL,
    default: true,
    description: '',
    ingredients: [],
    metadata: {},
    name: '',
    parameters: {},
    tags: [],
    recipe_id: recipeId,
    created_at: formattedDate,
    updated_at: formattedDate,
  }

  const stepObject: stepObjectInterface = {
    id: stepId,
    created_at: formattedDate,
    updated_at: formattedDate,
  }

  const recipeVariationStep: recipeVariationStepInterface = {
    recipeVariation_id: recipeVariatonId,
    step_id: stepId,
    step_rank: 0
  }

  const subStepArrayOutSideInst: outsideInstructionInterface = {
    id: subStepIdOutsideInstruction,
    subStepUId: subStepUId,
    media: {
      "loop": true,
      "muted": true,
      "title": "",
      "duration": 0,
      "imageURL": "",
      "videoURL": "",
      "startTime": 0
    },
    parameters: {
      "location": "Bowl",
      "outsideDescription": ""
    },
    type: "outsideInstruction",
    created_at: formattedDate,
    updated_at: formattedDate,
    name: "",
  }

  const subStepArrayTimerInst: timerInstructionInterface = {
    id: subStepIdInstruction,
    subStepUId: subStepUId,
    name: "",
    media: {
      "url": "",
      "loop": true,
      "muted": true,
      "title": "",
      "duration": 0,
      "startTime": 0
    },
    parameters: {
      "cap": "on",
      "scrape": false,
      "settings": [
        {
          "time": 0,
          "speed": 0,
          "exitTime": 4200,
          "stirDuty": 6,
          "stirAngle": 140,
          "scaleModel": {
            "type": "none"
          },
          "heatingMode": HeatingModeEnum.TAT,
          "temperature": 20,
          "strategyType": "manual"
        }
      ]
    },
    type: "instruction",
    created_at: formattedDate,
    updated_at: formattedDate,
  }

  const stepSubStepsArray: Array<recipeSubStepInterface> = [{
    step_id: stepId,
    subStep_id: subStepIdOutsideInstruction,
    subStepUId,
    subStep_rank: 0,
    SubstepsE3: subStepArrayOutSideInst,
  }, {
    step_id: stepId,
    subStep_id: subStepIdInstruction,
    subStepUId,
    subStep_rank: 1,
    SubstepsE3: subStepArrayTimerInst,
  }]

  return {
    recipeObject,
    recipeVariatonObject,
    stepObject,
    recipeVariationStep,
    stepSubStepsArray
  }
}